import { render, staticRenderFns } from "./PaymentCreate.vue?vue&type=template&id=5c034fb6&scoped=true&"
import script from "./PaymentCreate.vue?vue&type=script&lang=js&"
export * from "./PaymentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c034fb6",
  null
  
)

export default component.exports